

function BetOption({ sportcode, gameid }) {
    
    const buyThisPick = () => {
        let qs = `?gameid=${gameid}`;
        location.href = `/home/premiumpicks${qs}&sportscode=${sportcode}`;
    };

    const buySeasonPicks = () => {

        location.href = `/account/RegisterFiveStarClub?sportscode=${sportcode}`;
    };

    const login = () => {
       
    };


    return (

        
           
            <div>
                        <div className="d-flex justify-content-center mx-3 my-2 fw-bolder fs-5">
                            
                            <span>5-Star Picks are available to paid subscribers only</span>
                               
                        </div>

                        <hr />

            <div className="d-flex justify-content-center">


                <a
                    href="/inside-edge/subscription?action=1"
                    className="btn p-3 fs-5 fw-semibold text-dark border w-100 w-md-auto d-flex align-items-center justify-content-center gap-2 text-decoration-none"
                    style={{
                        backgroundImage: "linear-gradient(to right, rgb(171, 220, 255) 0%, rgb(194, 233, 251) 100%, rgb(161, 196, 253) 100%)",
                        transform: "translateY(-2px)"
                    }}
                >
                    <span>🔓</span>
                    <span>Subscribe to see more bets and reveal picks!</span>
                </a>

                            {/*<button id="buy-this-pick" onClick={buyThisPick} type="button" className="btn mx-2 w-50 fw-bold" style={{backgroundImage: "linear-gradient(to right, rgb(171, 220, 255) 0%, rgb(194, 233, 251) 100%, rgb(161, 196, 253) 100%)"}}>*/}
                            {/*    Reveal Pick <br />*/}
                            {/*        <span className="fs-3">$20</span>*/}
                            {/*</button>*/}
                            {/*<button id="star-club" onClick={buySeasonPicks} type="button" className="btn mx-2 fw-bold w-50" style={{backgroundImage: "linear-gradient(to right, rgb(171, 220, 255) 0%, rgb(194, 233, 251) 100%, rgb(161, 196, 253) 100%)"}}>*/}
                            {/*    Season Access<br />*/}
                            {/*        <span className="fs-3">$149</span>*/}
                            {/*</button>*/}
                         </div>

                         <div className="d-flex justify-content-center p-3">
                            <a href="#" className="btn btn-lg btn-outline-secondary positionreasons text-decoration-none mx-2 link-dark" data-bs-toggle="modal" data-bs-target="#modal-login-box" modal-tab-val="sign_in">
                                Or Login
                            </a>
                         </div>
            </div>

        )

}
export default BetOption;
